import React from "react";
import { Heading3, Paragraph } from "../../components/typography";
import { sortedTypes, allFadoel } from "./allFadoel";

export { sortedTypes, allFadoel };

const fadoelTypes = {
  Pilsner: {
    items: [3615, 4615],
    allItemsDescription: "Alle vores pilsnere:",
    content: (
      <React.Fragment>
        <Heading3>Pilsner</Heading3>
        <Paragraph>
          Den første pilsner brygget på undergær kom til verden i 1842 fra det
          tjekkiske bryggeri Měšťanský Pivovar i byen Pilsen (Plzeň). Den
          komplekse undergæringsteknik bredte sig herefter til resten af
          tjekkiet og senere til resten af verden. I dag bliver ordet
          &apos;pilsner&apos;, i tjekkiet, udelukkende brugt om øl fra Pilsen,
          men i Danmark er en Pilsner efterhånden blevet synonym med øl.
        </Paragraph>
        <Paragraph>
          Pilsnertypens smag er let syrlig og har desuden en let maltkarakter og
          let humlebitterhed. De stærkere pilsnere har den samme lette
          syrlighed, men indeholder en mærkbar maltkarakter og er tør til let
          sødlig, oftest med en middel humlebitterhed.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes.Pilsner || [],
  },
  Classic: {
    items: [3655, 8215],
    allItemsDescription: "Alle vores classic:",
    content: (
      <React.Fragment>
        <Heading3>Classic | Mørk Pilsner</Heading3>
        <Paragraph>
          Classic er den moderne version af den klassiske bayerske øl og blev
          introduceret til Danmark i 1993. Classic øltypen er i dag en del af
          sortimentet hos de fleste danske bryggerier.
        </Paragraph>
        <Paragraph>
          Classictypens smag er let syrlig og har desuden en let maltkarakter og
          let humlebitterhed.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes.Classic || [],
  },
  Hvedeøl: {
    items: [23785, 2485],
    allItemsDescription: "Alle vores hvedeøl:",
    content: (
      <React.Fragment>
        <Heading3>Hvedeøl</Heading3>
        <Paragraph>
          Hvedeøl er en overgæret øltype, der brygges på mindst 30% hvedemalt i
          Tyskland og en blanding af pilsnermalt og umaltet hvede i Belgien. I
          mange generationer er hvede øl blevet brygget i Tyskland og Belgien
          hvor de kaldes &apos;Weizenbier&apos; / &apos;Weißbier&apos;
          (Tyskland) og &apos;Witbier&apos; (Belgien).
        </Paragraph>
        <Paragraph>
          Belgisk hvedeøl er oftest friskt og kulsyreholdigt øl, der er krydret
          med koriander og appelsinskal. Tysk ufiltreret hvedeøl indeholder en
          del gær og har kraftigere, smag og fylde.
        </Paragraph>
        <Paragraph>
          Hvedeøl findes både filtreret og ufiltreret og kan være alt fra helt
          lyse til meget mørkebrune. Smagen er typisk syrlig og krydret med en
          kort sød eftersmag.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes.Hvedeøl || [],
  },
  IPA: {
    items: [8215, 39135],
    allItemsDescription: "Alle vores Indian Pale Ales:",
    content: (
      <React.Fragment>
        <Heading3>India Pale Ale (IPA)</Heading3>
        <Paragraph>
          India Pale Ale er en variant af pale ale med en mere humlet smag og
          har typisk en anelse højere alkoholprocent. Denne øltype har meget
          aroma og har en del bitterhed fra den ekstra humle.
        </Paragraph>
        <Paragraph>
          Denne øltype stammer fra england. Under kolonitiden i Indien var det
          for varmt at brygge øllet i Indien og derfor sejlede englænderne øllet
          til Indien. Da pasteurisering endnu ikke var opfundet havde øllet
          svært ved at holde til sejlturen. Man udviklede derfor en øltype med
          mere alkohol og mere humle for at det kunne holde bedre. Dette er hvad
          vi i dag kender som India Pale Ale.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes.IPA || [],
  },
  ["Lys Ale"]: {
    items: [23885, 8795],
    allItemsDescription: "Alle vores lyse ales:",
    content: (
      <React.Fragment>
        <Heading3>Lys Ale (Pale Ale)</Heading3>
        <Paragraph>
          I Belgien er lyse ales krydrede og komplekse, da der bruges særlige
          gærstammer og af og til bakterier i brygningen.
        </Paragraph>
        <Paragraph>
          Farven i lyse Ales strækker sig fra gullig til kobberrød og findes
          både i klare eller uklare typer. De lyse ales har ofte en intens
          maltkarakter med frugtige og krydrede aromaer. Smagen er hovedsagelig
          let til markant sød med en fyldig frugtsmag. Bitterheden strækker sig
          fra let til at være kraftig.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes["Lys Ale"] || [],
  },
  ["Mørk Ale"]: {
    items: [23895],
    allItemsDescription: "Alle vores mørke ales:",
    content: (
      <React.Fragment>
        <Heading3>Mørk Ale | Rød Ale</Heading3>
        <Paragraph>
          I Belgien er mørke ales fyldige og komplekse og typisk let syrlige og
          frugtige. Engelske mørke ales er mere diskrete, fyldige og samtidigt
          bløde med let til kraftig sødme.
        </Paragraph>
        <Paragraph>
          Farven i mørke ales strækker sig fra at være kobberrøde til at være
          kastaniebrune og findes både i klare eller uklare typer. De mørke ales
          har ofte en markant maltkarakter med en let smag af tørret frugt og
          nødder. Generelt er mørke ales sødlige og forholdsvis fyldige i smagen
          og bitterheden strækker sig fra let til at være kraftig.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes["Mørk Ale"] || [],
  },
  ["Brown Ale"]: {
    items: [4955, 12345],
    allItemsDescription: "Alle vores Brown Ale:",
    content: (
      <React.Fragment>
        <Heading3>Brown Ale</Heading3>
        <Paragraph>
          Brown Ale er en overgæret øltype, typisk set i form af den lyse, tørre
          og stærke nordengelske Brown Ale. Det klassiske eksempel på en Brown
          Ale finder man i form af Newcastle Brown Ale. Denne Brown Ale er
          maltbetonet med en nøddeagtig tørhed og en blid frugtaroma.
        </Paragraph>
        <Paragraph>
          De danske bryggerier stiller med et godt udvalg af Brown Ale i form af
          Ale no. 16, Skovlyst Bøgebryg og Jacobsen Brown Ale.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes["Brown Ale"] || [],
  },
  Stout: {
    items: [2745, 4835],
    allItemsDescription: "Alle vores stouts:",
    content: (
      <React.Fragment>
        <Heading3>Porter | Stout</Heading3>
        <Paragraph>
          Stouts bliver i populær tale kaldt portere i Danmark. En stout er
          tilnærmelsesvis også en porter, men en væsentlig forskel er at det kun
          er stouts der brygges med ristet byg. De bedste stouts er overgærede
          med en frugtrig syrlighed og kompleksitet.
        </Paragraph>
        <Paragraph>
          Den mest kendte stout er Guinness, som vi har i vores sortiment. Denne
          øl betegnes som en tør stout og er kendetegnet ved at være tør og har
          en skarp ristet smag, næsten syrligt ristet. De tørre stouts der
          brygges i Irland kan kendes på den sorte, cremede krop.
        </Paragraph>
      </React.Fragment>
    ),
    allTypes: sortedTypes.Stout || [],
  },
};

fadoelTypes.Porter = fadoelTypes.Stout;
fadoelTypes["Rød Ale"] = fadoelTypes["Mørk Ale"];
export default fadoelTypes;
